import { render, staticRenderFns } from "./UserSettingsDropdown.vue?vue&type=template&id=ca465896&scoped=true"
import script from "./UserSettingsDropdown.vue?vue&type=script&lang=ts"
export * from "./UserSettingsDropdown.vue?vue&type=script&lang=ts"
import style0 from "./UserSettingsDropdown.vue?vue&type=style&index=0&id=ca465896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca465896",
  null
  
)

export default component.exports